import { Link } from 'react-router-dom';
import { DefaultLogoUrl } from '~/utils/const';
import type { HeaderProps } from '~/types';

import './index.css';

// @ts-ignore
function Header({ isLoggedIn, userInfo, onLoginClick }: HeaderProps): JSX.Element {
  return (
    <>
      <header className="header">
        <div className="navbar_pc">
          <Link to="/" className="navbar_pc-logo" aria-label="Home">
            <img src={DefaultLogoUrl} alt="逗赛科技" />
            <span>逗赛科技</span>
          </Link>
        </div>
      </header>
    </>
  );
}

export default Header;
